import { render, staticRenderFns } from "./solutions-page.vue?vue&type=template&id=4ebe2071&scoped=true"
import script from "./solutions-page.vue?vue&type=script&lang=js"
export * from "./solutions-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebe2071",
  null
  
)

export default component.exports